export const POLICY_SCHEMA_KEY = 'policy';
